/**
 * RX Self-Pickup subscriptions: only the first order is picked up at the pharmacy. Every renewal is
 * built by the scheduler (buildNewOrderForSubscription) without the self-pickup flag, so it ships by
 * DHL to the address the customer enters on the Shipping page — same as Uber subscriptions.
 */

type SubscriptionCart = {
  subscription_plan_id?: number | null;
};

export const shouldShowSelfPickupSubscriptionDisclaimer = (cart: SubscriptionCart): boolean =>
  Boolean(cart.subscription_plan_id);

type AddressFormTitleParams = {
  isSelfPickup: boolean;
  isOnlyPrescription: boolean;
  isCannabisCatalog: boolean;
  isSubscription: boolean;
};

/**
 * Translation key (shipping namespace) for the address form title.
 * On self-pickup the form is only a billing address — unless the cart is a subscription, where the
 * same address becomes the DHL delivery address of every renewal.
 */
export const getAddressFormTitleKey = ({ isSelfPickup, isOnlyPrescription, isCannabisCatalog, isSubscription }: AddressFormTitleParams): string => {
  if (isSelfPickup && isSubscription) {
    return "layout/select_delivery_option_title_self_pickup_subscription";
  }
  if (isSelfPickup || (isOnlyPrescription && isCannabisCatalog)) {
    return "layout/select_delivery_option_title_self_pickup";
  }
  return "layout/living_address";
};
